var _rect, _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4996_1849",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.75C6.25 6.67893 7.92893 5 10 5C12.0711 5 13.75 6.67893 13.75 8.75V14.8058C13.75 14.9131 13.6631 15 13.5558 15H6.44417C6.33694 15 6.25 14.9131 6.25 14.8058V8.75Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.75C6.25 6.67893 7.92893 5 10 5C12.0711 5 13.75 6.67893 13.75 8.75V14.8058C13.75 14.9131 13.6631 15 13.5558 15H6.44417C6.33694 15 6.25 14.9131 6.25 14.8058V8.75Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_4996_1849)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.355e840e.svg";
export { ForwardRef as ReactComponent };